// ==========================================
// Styles
// ==========================================
import '../scss/theme.scss';

// ==========================================
// theme.js
// Bootstraps each page of site
// ==========================================

import $ from 'jquery';

// Make jQuery available globally for plugins
window.jQuery = window.$ = $;

// Vendor - stuff not on npm
// eslint-disable-next-line import/extensions
require('./vendor/jquery.dom-router.min.js');

// Util
import { globalUtils } from './util/globalUtils';
import { resize } from './util/resize';
// import { cartUtil } from './util/cartUtil';
// import { gaevents } from './util/gaEvents'

// Snippets
// import { search } from './theme/snippets/search';
// import { gwp } from './theme/snippets/gwp'

// Sections
import { header } from './theme/sections/header'
import { footer } from './theme/sections/footer-new'
// import { cartDrawer } from './theme/sections/cartDrawer'
import { cart } from './theme/sections/cart'
import { featuredCollection } from './theme/sections/featured-collection';
import { carousels } from './theme/sections/carousels';
// import { header } from './theme/sections/header'
// import { promotionPopup } from './theme/sections/promotionPopup';

// Templates
import { index } from './theme/templates/index';

// import { collectionnew } from './theme/templates/collection-new';
import { collection } from './theme/templates/collection';
// import { product } from './theme/templates/product';
import { product } from './theme/sections/product-section';
// import { cartPage } from './theme/templates/cart';
import { customers } from './theme/templates/customers';
// import { searchpage } from './theme/templates/searchpage'
import { fitguide } from './theme/templates/fitguide';
// import { fragrance } from './theme/templates/fragrance';
import { openNav } from './theme/snippets/openNav';

import marketingTiles from './theme/snippets/marketingTiles.js';

// Product Bundle
// import { productBundle } from './theme/sections/productBundle';
// Test Vue
// import { vueTest } from './theme/sections/vue-test';
// Vuex Store
import { store } from './vuex/store';
// Variables
// -----------------------------------
// let sections = new Sections();

// Routes
// -----------------------------------
$(() => {
  $(document).router({
    common() {
      globalUtils.init();
      resize.init();
      header.init();
      footer.init();
      // headernew.init();
      
      // cartUtil.init();
      // $(document).trigger('cart.ready', [window.Shop._CART_JSON_]);
      // gwp.init();
      // search.init();
      // if ( $(window).width() > 1113 ) {
      //   promotionPopup.registerSection();
      // }
      // gaevents.init();
      // $('#preview-bar-iframe').remove();
        // Initialize Vuex Store
        const process = null;
        store.dispatch('cart/updateCart');
        // cartDrawer.init();
        cart.init();
    },

    index() {
      index.init();
      featuredCollection.init();
      carousels.init();
    }, 

    collection() {
      // collectionnew.init(); 
      collection.init()
      marketingTiles()
    },

    collection_promo: function(){
      collection.init()
    },

    product() {
      product.registerSection();
      fitguide.init();
    },

    cart() {
      // cartPage.init();
    },

    CustomerPage() {
      customers.init();
    },

    FaqPage() {
      $('h6').click(function() {
        $(this).toggleClass("accordion");
        $(this)
          .next()
          .slideToggle('fast');
      });
    },
    ProductBundle() {
      product.registerSection();
      // vueTest.init();
    },

    search() {
      // searchpage.init();
      // collectionnew.init();
    },

    FitGuide() {
      fitguide.init();
      openNav.init();
    },

    page() {
      // fragrance.init();
    },

    blog() {
      openNav.init();
    }
  });
});
